import React from "react";
import { MARK_GRID, MARK_SHAPES } from "../../lib/brandMark";

/**
 * Solstack — the mark: a bold "S" on a blue square with a black rule and a
 * hard black shadow (src/lib/brandMark.js, the same shapes as the favicon
 * and the link-preview cards). The shadow is part of the drawing, so the
 * element carries no box-shadow of its own. Borders and shadows stay black
 * in dark mode, as everywhere on the site.
 */
export const SolstackMark = ({ size = 28, className }) => (
  <svg
    aria-hidden="true"
    className={className}
    viewBox={`0 0 ${MARK_GRID} ${MARK_GRID}`}
    width={size}
    height={size}
    style={{ display: "block", flex: "none" }}
    // Static shapes from brandMark.js, no user input.
    dangerouslySetInnerHTML={{ __html: MARK_SHAPES }}
  />
);

// aliases so existing imports keep working
export const LogoMark = SolstackMark;
export const SolstackPadMark = SolstackMark; // legacy alias

export const Logo = ({
  size = 26,
  showText = true,
  tone = "ink",
  product = "Solstack",
  className,
}) => (
  <span
    className={className}
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: size * 0.32,
      fontFamily: "var(--font-display)",
    }}
  >
    <SolstackMark size={size} />
    {showText && (
      <span
        style={{
          fontSize: size * 0.72,
          fontWeight: 800,
          letterSpacing: "-0.03em",
          lineHeight: 1,
          color: tone === "white" ? "#fff" : "var(--ink)",
        }}
      >
        {product}
      </span>
    )}
  </span>
);
